__turbopack_context__.v({
  "container": "index-module-scss-module__n-XwNW__container",
  "expand-search": "index-module-scss-module__n-XwNW__expand-search",
});
